export const DELAY = 300;
export const TRANSITION_TIMEOUT = 5000;

export const notificationAlertClassName = `
    fixed bottom-10 right-10 z-[1100]
    bg-white w-[400px] pb-sm
    border-gray-90 rounded-sm shadow
  `;
